import dayjs from "@/lib/dayjs";
import classNames from "classnames";

import styles from "./calendar.module.css";
import { DAY_NAMES } from "@/lib/week_days";

export default function Calendar({
  date,
  assets,
  bookings,
  timezone,
  className,
}) {
  const startOfDay = dayjs.tz(date, timezone).startOf("day");
  const dateDayName = DAY_NAMES[dayjs.tz(date, timezone).day()];

  const minStart = Math.min(...assets.map(a => a.working_hours_start));
  const maxEnd   = Math.max(...assets.map(a => a.working_hours_end));
  const firstSlot = minStart / 15;
  const totalSlots = (maxEnd - minStart) / 15;

  let hours = [];
  for (let h = Math.floor(minStart / 60); h < Math.ceil(maxEnd / 60); h++) {
    const minutesFromMidnight = h * 60;
    if (minutesFromMidnight >= minStart && minutesFromMidnight <= maxEnd) {
      hours.push(minutesFromMidnight);
    }
  }

  return (
    <div className={classNames(styles.container, className)}>
      <div
        className={styles.contentArea}
        style={{ gridColumnEnd: `span ${assets.length + 1}`, gridRowEnd: `span ${totalSlots}` }}
      ></div>
      <div
        className={styles.assetsLineBackground}
        style={{ gridRow: 1, gridColumn: `1 / span ${assets.length + 1}` }}
      ></div>
      {assets.map((asset, i) => (
        <div
          key={asset.id}
          className={styles.assetCell}
          style={{ gridRow: 1, gridColumn: i + 2 }}
        >
          {asset.name}
        </div>
      ))}
      {hours.map((h) => (
        <div
          key={h}
          className={styles.hourCell}
          style={{ gridColumn: 1, gridRow: `${((h - minStart) / 15) + 2} / span 4` }}
        >
          <span>{String(Math.floor(h / 60)).padStart(2, "0")}:{String(h % 60).padStart(2, "0")}</span>
        </div>
      ))}
      {assets.map((asset, i) => {
        const divs = [];
        if (!asset.working_wdays.includes(dateDayName)) {
          return (
            <div
              key={`inactive-wday-${asset.id}`}
              className={styles.inactiveArea}
              style={{ gridColumn: i + 2, gridRow: `2 / ${totalSlots + 2}` }}
            />
          );
        }
        if (asset.working_hours_start > minStart) {
          const topSlots = (asset.working_hours_start - minStart) / 15;
          divs.push(
            <div
              key={`inactive-top-${asset.id}`}
              className={styles.inactiveArea}
              style={{ gridColumn: i + 2, gridRow: `2 / ${2 + topSlots}` }}
            />
          );
        }
        if (asset.working_hours_end < maxEnd) {
          const endRow = (asset.working_hours_end - minStart) / 15 + 2;
          const endTotalRow = totalSlots + 2;
          divs.push(
            <div
              key={`inactive-bottom-${asset.id}`}
              className={styles.inactiveArea}
              style={{ gridColumn: i + 2, gridRow: `${endRow} / ${endTotalRow}` }}
            />
          );
        }
        return divs;
      })}
      {bookings.map((booking, i) => {
        const assetIndex = assets.findIndex(asset => asset.id === booking.asset_id);

        const timeStartIndex = ((dayjs(booking.starts_at).unix() - startOfDay.unix()) / 60) / 15;
        const timeEndIndex = ((dayjs(booking.ends_at).unix() - startOfDay.unix()) / 60) / 15;

        return (
          <div
            key={booking.id}
            className={styles.bookingArea}
            style={{ gridColumn: assetIndex + 2, gridRow: `${timeStartIndex - firstSlot + 2} / ${timeEndIndex - firstSlot + 2}` }}
          >
            <p>Booking #{booking.id}</p>
            <p>{dayjs(booking.starts_at).tz(timezone).format("HH:mm")} — {dayjs(booking.ends_at).tz(timezone).format("HH:mm")}</p>
          </div>
        )
      })}
    </div>
  );
}
